module.exports = function (a) {
    var guid = $(this).data('guid');
    var url = $(this).data('url');
    var title = $(this).data('title');
    var artist = $(this).data('artist');
    var cover = $(this).data('cover');
    var share_link = 'javascript:add_to_cart(\''+guid+'\');';

    if(!window.fapPopupWin){
        $.fullwidthAudioPlayer.clear();
    }

    $.fullwidthAudioPlayer.addTrack(url, artist + ' - ' + title, '', cover, share_link, !window.fapPopupWin); //!window.fapPopupWin

    if(!window.fapPopupWin){
        // $.fullwidthAudioPlayer.play();
        $.fullwidthAudioPlayer.setPlayerPosition('open', true);
        $.fullwidthAudioPlayer.setPlayerPosition('closePlaylist', true);
    }
};

